<script>
    import store from '@/store/global.store';
    import httpService from '@/services/core/http.service';
    import AdminGrid from '@/components/shared/AdminGrid';
    import { DxColumn } from 'devextreme-vue/data-grid';
    import modalService from '@/services/core/modal.service';
    import UserModal from '@/components/modals/UserModal';

    export default {
        components: {
            AdminGrid,
            DxColumn
        },
        data() {
            return {
                dataSource: httpService.getDxDataSource('users/grid')
            };
        },
        computed: {
            isReadOnly() {
                return store.getters.currentUser()?.isReadOnly === true;
            }
        },
        methods: {
            onEdit(item) {
                modalService.show(UserModal, {
                    item,
                    onSuccess: () => {
                        this.$refs['userGrid'].refresh();
                    }
                });
            }
        }
    };
</script>

<template>
    <div class="main-content-header">
        <h3>
            <i class="bi-person-lines-fill"></i>
            Users
        </h3>
    </div>
    <div class="main-content-body">
        <AdminGrid :data-source="dataSource" storage-key="user-list" ref="userGrid">
            <DxColumn data-field="id" />
            <DxColumn data-field="fullName" caption="Name" />
            <DxColumn data-field="username" caption="User Name" />
            <DxColumn data-field="password" />
            <DxColumn data-field="email" />
            <DxColumn data-field="phoneNumber" caption="Phone" />
            <DxColumn data-field="company" />
            <DxColumn data-field="role" />
            <DxColumn data-field="bookie" />
            <DxColumn data-field="contractType" />
            <DxColumn data-field="lastSeen" caption="Last seen" data-type="date" />

            <template #actions="{ item }">
                <button type="button" class="btn btn-link py-0 lh-1" title="Edit" @click="onEdit(item.data)">
                    <i class="bi bi-pencil"></i>
                </button>
            </template>
        </AdminGrid>
    </div>
</template>
